import BaseSplitPage from "../../components/splitpage";
import { notification } from 'antd';
import dayjs from 'dayjs';
import {DescriptionText, FlexContainer, Spinner} from "../../design";
import currencyFormatter from "../../utils/currencyformatter";
import {AmountDivideByHundred} from "../../helper";
import Support from "../../components/support";
import PaymentMethodTabs from "../../components/paymentmethodtabs";
import getMenuTabs from "../../utils/getMenuTabs";
import TransactionModal from "../../components/modal/transaction";
import SuccessModal from "../../components/modal/success";
import React, {useEffect, useState} from "react";
import {
  MESSAGES,
  SUPPORTED_PAYMENT_TYPES,
  SWIREPAY_URL,
  TabNames,
  WOOCOMMERCE_ORDER_STATUS,
  WOOCOMMERCE_ORDER_STATUS_ERROR,
  LPG_CUSTOMER,
} from "../../appconstants";
import {cancelWooCommerceOrderByGid, geWooCommerceOrderByGid, wooCommerceOrderChargeByGid, getHealthCheck} from "../../api";
import CardPayment from "../../components/cardpayment/CardPayment";
import WooCommerceLeftSideContent from "./left/WooCommerceLeftSideContent";
import SmallScreenHeader from "../../components/smallscreen/header";
import AlertModal from "../../components/modal/alert";
import WARNING_ICON from "../../assets/imgs/exclamation_warning.svg";
import SUCCESS_ICON from "../../assets/imgs/success.svg";
import getUniquePaymentTypes from "../../utils/getUniquePaymentTypes";
import AchPayment from "../../components/achPaymentWithPlaid";
import UPIIMAGE from "../../assets/imgs/upiNotification.svg";

type Props = {
  history: {
    push: Function,
  },
}

const WooCommercePayment = (props: Props) => {

  const { match: { params: { wooCommerceOrderGid } }, location: { pathname, search } } = props;
  const [isTransactionModalOpen, setTransactionModalOpen] = useState(false);
  const [isTransactionSuccessModalOpen, setTransactionSuccessModalOpen] = useState(false);
  const [order, setOrder] = useState(null);
  const [account, setAccount] = useState(null);
  const [errorMessage, setErrorMessage] = useState();
  const [isShowSpinner, setShowSpinner] = useState(false);
  const [customer, setCustomer] = useState(null);
  const [submitBtnText, setSubmitBtnText] = useState(null);
  const [supportedPaymentTypes, setSupportedPaymentTypes] = useState([]);
  const defaultAlertConfig = {
    showIcon:false, isOpen:false, hideBtn: true,
    cancel: null, header:null, body: null,
    submitBtnText: null, cancelBtnText: null, showCancelBtn: false,
    showSubmitBtn: false, submit: null, icon: null
  };
  const [selectedTab, setSelectedTab] = useState(parseInt(localStorage.getItem(`${wooCommerceOrderGid}-tap-index`) || 0));
  const [tabName, setTabName] = useState('');
  const [alertConfig, setAlertConfig] = useState(defaultAlertConfig);

  const [ipAddress, setIpAddress] = useState('');
  const [upiDownTime, setUpiDownTime] = useState(false);
  const accountGid = [
    'account-cdfe7eecff324778a88a2727177a1c8f'
  ];
  const [plaidPublicToken, setPlaidPublicToken] = useState(() => localStorage.getItem(`plaidPublicToken-${wooCommerceOrderGid}`) || undefined);

  const getData = async () => {
    const response = await fetch('https://api.ipify.org/?format=json');
    const data = await response.json();
    setIpAddress(data.ip);
  }

  useEffect(() => {
    getData();
  }, []);

  useEffect( () => {
    if (search) {
      getWooCommerceOrderWithSearchValue();
    } else {
      getWooCommerceOrderWithoutSearchValue();
    }
  }, [wooCommerceOrderGid, search]);

  useEffect(() => {
    const paymentTypes = new Set();
    paymentTypes.add(TabNames.CARD);
    if(account) {
      for (let key in SUPPORTED_PAYMENT_TYPES) {
        account.supportedPaymentTypes && account.supportedPaymentTypes.forEach(value => {
          if(SUPPORTED_PAYMENT_TYPES[key] && SUPPORTED_PAYMENT_TYPES[key].includes(value)) {
            paymentTypes.add(key)
          }
        });
      }
    }
    setSupportedPaymentTypes([...paymentTypes])
  }, [account]);

  useEffect(() => {
    if (order && order.currency && order.amount) {
      setSubmitBtnText(`PAY ${currencyFormatter(AmountDivideByHundred(order.amount), order.currency)}`)
    }
    setCustomer(order && order.paymentSession && order.paymentSession.paymentMethod && order.paymentSession.paymentMethod.customer);
  }, [order]);

  useEffect(() => {
    setErrorMessage(null);
  }, [selectedTab]);

  const redirectBasedOnStatus = (status, wooCommerceReturnUrl) => {
    if (WOOCOMMERCE_ORDER_STATUS.PENDING !== status) {
      let redirectUrl = wooCommerceReturnUrl ? wooCommerceReturnUrl : SWIREPAY_URL;
      const urlPath = redirectUrl.includes("?");
      if (urlPath) {
        redirectUrl = `${redirectUrl}&status=${status}`;
      } else if (!urlPath) {
        redirectUrl = `${redirectUrl}?status=${status}`;
      }
      window.location = encodeURI(redirectUrl);
    }
  };

  const getWooCommerceOrderWithSearchValue = async () => {
    const params = new URLSearchParams(search);
    if (!(params.get('ps') || params.get('mp')) || !params.get('secret')) {
      props.history.push(`${pathname}/error`);
      return;
    }
    setShowSpinner(true);
    try {
      const value = await geWooCommerceOrderByGid(wooCommerceOrderGid, search);
      if (value) {
        const { redirectUri, status } = value;
        setAccount(value.account);
        setOrder(value);
        if(WOOCOMMERCE_ORDER_STATUS.PAID === status) {
          setTransactionSuccessModalOpen(true);
          setTimeout(function () {
            redirectBasedOnStatus(status, redirectUri);
          }, 5000);
        }
      }
    } catch (reason) {
      try {
        const value = await geWooCommerceOrderByGid(wooCommerceOrderGid, null);
        if (value) { setOrder(value); setAccount(value.account); }
      } catch (e) {
        props.history.push(`${pathname}/error`);
      }
      error(reason);
    } finally {
      setShowSpinner(false);
    }
  };

  const getWooCommerceOrderWithoutSearchValue = async () => {
    setShowSpinner(true);
    try {
      const value = await geWooCommerceOrderByGid(wooCommerceOrderGid, null);
      if (value) {
        const { status, redirectUri } = value;
        setOrder(value);
        setAccount(value.account);
        redirectBasedOnStatus(status, redirectUri);
        // if (value.account.integratedMerchant && LPG_CUSTOMER.includes(atob(value.account.integratedMerchant))) {
        //   const val = await getHealthCheck();
        //   if (val && val.status !== 'ACTIVE') {
        //     setUpiDownTime(true);
        //     notification.open({
        //         message: '',
        //         description: <img src={UPIIMAGE} alt="" />,
        //       });
        // }
        // }
      }
    } catch (e) {
      props.history.push(`${pathname}/error`);
    } finally {
      setShowSpinner(false)
    }
  };

  const getCustomerGidFromOrder = () => {
    return order && order.customer && order.customer.gid;
  };

  const chargeByCard = async (data) => {
    const userAgent = {
      acceptHeaders: "Accept: text/html, application/xhtml+xml, application/xml;q=0.9, image/webp, */*;q=0.8", 
      ip: ipAddress,
      language: window.navigator.language, 
      colorDepth: window.screen.colorDepth,
      screenHeight: window.screen.height, 
      screenWidth: window.screen.width,
      timeZone: new Date().getTimezoneOffset(), 
      browserUserAgent: window.navigator.userAgent
     };
     data.userAgent = userAgent;
    await chargeByGid(data);
  };

  const chargeByAch = async (data) => {
    const { customer, paymentMethod } = data;
    await chargeByGid({ customer, paymentMethod, customerGid: getCustomerGidFromOrder(order) });
  };

  const error = reason => {
    setErrorMessage(null);
    const { data: { message, messageCode }, status } = reason;
    setErrorMessage(message);
    if (status === 500) {
      setErrorMessage(MESSAGES.PAYMENT_LINK.ERROR);
    }
    setTransactionModalOpen(false);
    resetAlertConfig();
    const errorEl = document.getElementById("error");
    if (null !== errorEl) { errorEl.scrollIntoView(); }
  };

  const chargeByGid = async (data) => {
    setTransactionModalOpen(true);
    try {
      const value = await wooCommerceOrderChargeByGid(wooCommerceOrderGid, data);
      if (value) {
        const { paymentSession, redirectUri, status} = value;
        if (paymentSession && paymentSession.nextActionUrl) {
          window.location = paymentSession.nextActionUrl;
          return;
        }
        setTransactionModalOpen(false);
        setTransactionSuccessModalOpen(true);
        setTimeout(function () {
          redirectBasedOnStatus(status, redirectUri);
        }, 5000);
        if (wooCommerceOrderGid) { localStorage.removeItem(`${wooCommerceOrderGid}-tap-index`) }
      }
    } catch (reason) {
      error(reason);
    }
  };

  const cancelOrder = async () => {
    setAlertConfig({...defaultAlertConfig,
      showIcon: true, isOpen: true, hideBtn: true,
      header: `Please Wait!. Your Order cancel is being processed`, body: "You will be redirected when the cancel is successful.",
    });
    if(order && order.gid) {
      try {
        const value = await cancelWooCommerceOrderByGid(order.gid);
        if (value) {
          const {redirectUri, status } = value;
          setAlertConfig({...defaultAlertConfig,
            showIcon:true, isOpen:true, hideBtn: true,
            header: "Order cancel Completed", body: "You will be redirected automatically.",
            icon: SUCCESS_ICON
          });
          setTimeout(function () {
            redirectBasedOnStatus(status, redirectUri);
          }, 5000);
        }
      } catch (reason) {
        error(reason)
      }
    }
  };

  const cancelAlertOpen = () => {
    setAlertConfig({
      showIcon:true, isOpen:true, hideBtn: false,
      cancel: resetAlertConfig, header: "Are you sure!", body: "You will not be able to recover this order",
      submitBtnText: "Yes, cancel it!", cancelBtnText: "Cancel", showCancelBtn: true,
      showSubmitBtn: true, submit: cancelOrder, icon: WARNING_ICON
    });
  };

  const resetAlertConfig = () => {
    setAlertConfig(defaultAlertConfig)
  };

  const uniquePaymentTypes = supportedPaymentTypes ? getUniquePaymentTypes(supportedPaymentTypes) : '';
  const tabPanels = uniquePaymentTypes ? uniquePaymentTypes.reduce(function (panel, name) {
    let children;
    if (name === TabNames.ACH_LEGACY) {
      children = <AchPayment
        cancel={cancelAlertOpen}
        errorMsg={errorMessage}
        errorHeader={null}
        customerReadOnly={false}
        submit={chargeByAch}
        preFillCustomer={customer}
        customerDisabled={true}
        headerText={accountGid.includes(account?.gid) ? "Pay With BANK" : "Pay With ACH"}
        buttonText={submitBtnText}
        customerValidation={true}
        cancelButtonText={"Cancel"}
        showCancelBtn={true}
        alpha2={account && account.currency && account.currency.countryAlpha2}
        plaidPublicToken={plaidPublicToken}
        setPlaidPublicToken={setPlaidPublicToken}
        accountGid={account?.gid}
        paymentLinkId={wooCommerceOrderGid}
        isTest={account?.portal?.test}
        enableConsentCheckbox={true} 
        accountName={account?.name}
        paymentDate={dayjs().format('MMMM D, YYYY')}
        finalPayAmount={order?.amount && order?.currency ? currencyFormatter(AmountDivideByHundred(order.amount), order.currency) : null}
      />
    } else if (name === TabNames.CARD) {
      children = <CardPayment
        errorMsg={errorMessage}
        errorHeader={null}
        customerReadOnly={false}
        submit={chargeByCard}
        preFillCustomer={customer}
        headerText={"Pay With Card"}
        buttonText={submitBtnText}
        customerValidation={true}
        alpha2={account && account.currency && account.currency.countryAlpha2}
        currentDateObject={null}
        disableButtonText={null}
        planStartDate={null}
        showAddress={false}
        cancelButtonText={"Cancel"}
        showCancelBtn={true}
        cancel={cancelAlertOpen}
      />
    }  else {
      children = <DescriptionText>Processing payment. Please wait...</DescriptionText>
    }
    panel.push({ children });
    return panel;
  }, []) : [
    {
      children: <CardPayment
        errorMsg={errorMessage}
        errorHeader={null}
        customerReadOnly={false}
        submit={chargeByCard}
        preFillCustomer={customer}
        headerText={"Pay With Card"}
        buttonText={submitBtnText}
        customerValidation={true}
        alpha2={account && account.currency && account.currency.countryAlpha2}
        currentDateObject={null}
        disableButtonText={null}
        planStartDate={null}
        showAddress={false}
        cancelButtonText={"Cancel"}
        showCancelBtn={true}
        cancel={cancelAlertOpen}
      />
    }
  ];

  useEffect(() => {
    setTabName(uniquePaymentTypes && uniquePaymentTypes[selectedTab]);
  }, [selectedTab, uniquePaymentTypes]);


  return (
    <>
      <BaseSplitPage left={
        <>
          <FlexContainer
            flexDirection="column"
            position="relative"
            display="block"
            height="100%"
          >
            <WooCommerceLeftSideContent order={order}/>
            <div style={{ position: "sticky", top: "85%" }}>
              <Support email={order && order.support && order.support.email}
                       phone={order && order.support && order.support.phone} />
            </div>
          </FlexContainer>
        </>
      } right={
        <>
          <SmallScreenHeader>
            <WooCommerceLeftSideContent order={order}/>
          </SmallScreenHeader>
          <PaymentMethodTabs
            name={wooCommerceOrderGid}
            paymentTypes={account && account.currency && account.currency.countryAlpha2}
            tabs={getMenuTabs(uniquePaymentTypes)}
            tabPanels={tabPanels}
            defaultSelectedTab={selectedTab || 0}
            onSelect={data => setSelectedTab(data)}
            tabName={tabName}
            upiDown={upiDownTime}
            accountGid={account?.gid}
          />
          <TransactionModal body={null} header={null} isOpen={isTransactionModalOpen} />
          <SuccessModal isOpen={isTransactionSuccessModalOpen}  partnerConnection={false} successMsg={null}/>
          <Spinner isOpen={isShowSpinner} />
          <AlertModal
            showIcon={alertConfig.showIcon}
            isOpen={alertConfig.isOpen}
            hideBtn={alertConfig.hideBtn}
            cancel={alertConfig.cancel}
            header={alertConfig.header}
            body={alertConfig.body}
            submitBtnText={alertConfig.submitBtnText}
            cancelBtnText={alertConfig.cancelBtnText}
            showCancelBtn={alertConfig.showCancelBtn}
            showSubmitBtn={alertConfig.showSubmitBtn} submit={alertConfig.submit} icon={alertConfig.icon}/>
        </>
      } />
      );
    </>
  )
};

export default WooCommercePayment
